<template>
	<div class="custom-navigation pt-3" style="background-color: #f8f8f8;">
		<nav class="navbar navbar-expand-lg navbar-light">
            <div class="container">
                <div class="navbar-translate">
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-bar top-bar"></span>
                        <span class="navbar-toggler-bar middle-bar"></span>
                        <span class="navbar-toggler-bar bottom-bar"></span>
                    </button>
                </div>
                
                <div class="collapse navbar-collapse justify-content-center" id="navigation" data-nav-image="./assets/img/blurred-image-1.jpg">
                    <ul class="navbar-nav">
                        <li class="nav-item mx-5">
							<a class="nav-link" href="#expertise" v-scroll-to="'#expertise'">
								<p class="navigation-item text-dark">Expertise</p>
							</a>
						</li>

						<li class="nav-item mx-5">
							<a class="nav-link" href="#services" v-scroll-to="'#services'">
								<p class="navigation-item text-dark">Services</p>
							</a>
						</li>

						<li class="nav-item mx-5">
							<a class="nav-link" href="#featuredWork" v-scroll-to="'#featuredWork'">
								<p class="navigation-item text-dark">Featured Work</p>
							</a>
						</li>

						<li class="nav-item mx-5">
							<a class="nav-link" href="#testimonials" v-scroll-to="'#testimonials'">
								<p class="navigation-item text-dark">Testimonials</p>
							</a>
						</li>

						<li class="nav-item mx-5">
							<a class="nav-link" href="#contact" v-scroll-to="'#contact'">
								<p class="navigation-item text-dark">Contact</p>
							</a>
						</li>
                    </ul>
                </div>
            </div>
        </nav>
	</div>
</template>

<script>

export default {
	name: 'Navigation'
}
</script>